import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import styles from './Table.module.css';
function Cell(t0) {
  const $ = _c(17);
  let children;
  let className;
  let maxWidth_;
  let t1;
  let widths;
  if ($[0] !== t0) {
    ({
      children,
      className,
      as: t1,
      maxWidth: maxWidth_,
      ...widths
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = maxWidth_;
    $[4] = t1;
    $[5] = widths;
  } else {
    children = $[1];
    className = $[2];
    maxWidth_ = $[3];
    t1 = $[4];
    widths = $[5];
  }
  const Tag = t1 === undefined ? "td" : t1;
  const cellClass = Tag === "th" ? styles.headerCell : styles.cell;
  const maxWidth = maxWidth_ === Number.POSITIVE_INFINITY ? undefined : maxWidth_;
  let t2;
  if ($[6] !== cellClass || $[7] !== className) {
    t2 = classNames(cellClass, className);
    $[6] = cellClass;
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== maxWidth || $[10] !== widths) {
    t3 = {
      ...widths,
      maxWidth,
      "--cell-width": widths.width
    };
    $[9] = maxWidth;
    $[10] = widths;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = t3 as CSSProperties;
  let t5;
  if ($[12] !== Tag || $[13] !== children || $[14] !== t2 || $[15] !== t4) {
    t5 = <Tag className={t2} style={t4}>{children}</Tag>;
    $[12] = Tag;
    $[13] = children;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export default Cell;